__turbopack_context__.v({
  "ambient": "helpCenter-module__3lMhXq__ambient",
  "articleArrow": "helpCenter-module__3lMhXq__articleArrow",
  "articleAside": "helpCenter-module__3lMhXq__articleAside",
  "articleAsideMeta": "helpCenter-module__3lMhXq__articleAsideMeta",
  "articleBody": "helpCenter-module__3lMhXq__articleBody",
  "articleBreadcrumbs": "helpCenter-module__3lMhXq__articleBreadcrumbs",
  "articleCallout": "helpCenter-module__3lMhXq__articleCallout",
  "articleCard": "helpCenter-module__3lMhXq__articleCard",
  "articleCardCopy": "helpCenter-module__3lMhXq__articleCardCopy",
  "articleCategory": "helpCenter-module__3lMhXq__articleCategory",
  "articleFigure": "helpCenter-module__3lMhXq__articleFigure",
  "articleHeader": "helpCenter-module__3lMhXq__articleHeader",
  "articleLayout": "helpCenter-module__3lMhXq__articleLayout",
  "articleList": "helpCenter-module__3lMhXq__articleList",
  "articlePage": "helpCenter-module__3lMhXq__articlePage",
  "articleScreenshotDark": "helpCenter-module__3lMhXq__articleScreenshotDark",
  "articleScreenshotFrame": "helpCenter-module__3lMhXq__articleScreenshotFrame",
  "articleScreenshotLight": "helpCenter-module__3lMhXq__articleScreenshotLight",
  "articleSection": "helpCenter-module__3lMhXq__articleSection",
  "articleSteps": "helpCenter-module__3lMhXq__articleSteps",
  "availabilityList": "helpCenter-module__3lMhXq__availabilityList",
  "badge": "helpCenter-module__3lMhXq__badge",
  "badges": "helpCenter-module__3lMhXq__badges",
  "breadcrumbs": "helpCenter-module__3lMhXq__breadcrumbs",
  "categoryCard": "helpCenter-module__3lMhXq__categoryCard",
  "categoryCopy": "helpCenter-module__3lMhXq__categoryCopy",
  "categoryCount": "helpCenter-module__3lMhXq__categoryCount",
  "categoryGrid": "helpCenter-module__3lMhXq__categoryGrid",
  "categoryHeader": "helpCenter-module__3lMhXq__categoryHeader",
  "categoryHeaderIcon": "helpCenter-module__3lMhXq__categoryHeaderIcon",
  "categoryIcon": "helpCenter-module__3lMhXq__categoryIcon",
  "contentWrap": "helpCenter-module__3lMhXq__contentWrap",
  "emptySearch": "helpCenter-module__3lMhXq__emptySearch",
  "eyebrow": "helpCenter-module__3lMhXq__eyebrow",
  "featuredGrid": "helpCenter-module__3lMhXq__featuredGrid",
  "helpCenterHome": "helpCenter-module__3lMhXq__helpCenterHome",
  "hero": "helpCenter-module__3lMhXq__hero",
  "languageNotice": "helpCenter-module__3lMhXq__languageNotice",
  "main": "helpCenter-module__3lMhXq__main",
  "pageShell": "helpCenter-module__3lMhXq__pageShell",
  "relatedGrid": "helpCenter-module__3lMhXq__relatedGrid",
  "searchArea": "helpCenter-module__3lMhXq__searchArea",
  "searchBox": "helpCenter-module__3lMhXq__searchBox",
  "searchResultCount": "helpCenter-module__3lMhXq__searchResultCount",
  "searchResultList": "helpCenter-module__3lMhXq__searchResultList",
  "searchResults": "helpCenter-module__3lMhXq__searchResults",
  "section": "helpCenter-module__3lMhXq__section",
  "sectionHeading": "helpCenter-module__3lMhXq__sectionHeading",
  "sectionKicker": "helpCenter-module__3lMhXq__sectionKicker",
  "topBar": "helpCenter-module__3lMhXq__topBar",
  "topBarDivider": "helpCenter-module__3lMhXq__topBarDivider",
  "topBarInner": "helpCenter-module__3lMhXq__topBarInner",
  "topicList": "helpCenter-module__3lMhXq__topicList",
});
